import 'react'
import { useMutation } from 'react-query'
import axios from 'axios'
import { API_URL } from '../../config'

export const updatePurchaseOrderItem = async (updatePurchaseOrderItem) => {
  const { id, ...changedFields } = updatePurchaseOrderItem

  if (!id) throw 'No Id Supplied'
  //MAKING THE UPDATE API CALL
  const updatePurchaseOrderItemAPIPath = `${API_URL}/api/purchaseOrder/v1/update/${id}`
  const res = await axios.patch(updatePurchaseOrderItemAPIPath, changedFields)
  return res.data
}

export function useUpdatePurchaseOrder() {
  return useMutation(updatePurchaseOrderItem)
}

export const addPurchaseOrderItem = async (newItem) => {
  const addPurchaseOrderItemAPIPath = `${API_URL}/api/purchaseOrder/v1/new`
  return await axios.post(addPurchaseOrderItemAPIPath, newItem)
}

export function useAddPurchaseOrder() {
  return useMutation(addPurchaseOrderItem)
}

export const deletePurchaseOrderItem = async ({ id }) => {
  if (!id) throw 'Supply Id to delete'
  const deletePurchaseOrderItemAPIPath = `${API_URL}/api/purchaseOrder/v1/${id}`
  return await axios.delete(deletePurchaseOrderItemAPIPath)
}

export function useDeletePurchaseOrder() {
  return useMutation(deletePurchaseOrderItem)
}
